import { useScreenDetect } from '@sgcmpteltd/uikit-next';
import cx from 'clsx';
import Link from 'next/link';

import { CoverLinkList } from '@/components/cover-link-list';
import { joinSgcmMobileSite, joinSgcmSite } from '@/utils/url/join/public';

import { Item } from './item';
import styles from './styles.module.scss';
import type { Component } from './types';

export const PastCarList: Component = ({
  items,
}) => {
  const { isDesktop } = useScreenDetect();
  const isDesktopMode = isDesktop();

  return (
    <CoverLinkList
      contentContainerClassName={cx(
        styles.containerCoverLinkList,
        styles.isBehind,
      )}>
      {
        items.map((pastCar) => {
          const {
            id,
            make,
            model,
            launchedYear,
            endedYear,
            thumbnailUrl,
          } = pastCar;

          return (
            <Link
              key={id}
              href={isDesktopMode
                ? `${joinSgcmSite(`/new_cars/newcars_overview.php?CarCode=${id}`)}`
                : `${joinSgcmMobileSite(`/new_cars/overview.php?CarCode=${id}`)}`}>
              <Item
                endedYear={endedYear}
                launchedYear={launchedYear}
                make={make}
                model={model}
                thumbnailUrl={thumbnailUrl} />
            </Link>
          );
        })
      }
    </CoverLinkList>
  );
};
